module.exports = __webpack_public_path__ + "accb07fa21a879da2f79c8aa75732cfc.svg";